<template>
  <div class="lobby">
    <b-loading :is-full-page="false" v-model="isLoading"></b-loading>

    <div v-if="userId" class="lobby__header">
      <div class="lobby__headerLeft">
        <PlayersCarousel
          :onlinePlayers="getOnlinePlayers"
          cardType="top"
          :cardSize="128"
        />
      </div>
      <div class="lobby__headerRight">
        <CreateGame
          :currentMatch="currentMatch"
          :waitingTime="waitingTime"
          @onCreateMatch="createOrJoinMatch"
          @onCancelMatch="cancelMatch"
        />
      </div>
    </div>

    <div v-show="createdMatches.length" class="mt-6">
      <p class="subtitle is-3 has-text-warning-dark mb-0">OPEN GAMES</p>
      <div>
        <MatchesTable
          :currentMatch="currentMatch"
          :matches="createdMatches"
          :created="true"
          @onJoinMatch="joinMatch"
        />
      </div>
    </div>

    <div v-show="liveMatches.length" class="mt-6">
      <button
        class="button is-link"
        v-show="!showLiveGames"
        @click="showLiveGames = true"
      >
        Show Live Games ({{ liveMatchesFiltered.length }})
      </button>
      <div v-if="showLiveGames">
        <router-link to="/live">
          <p class="subtitle is-3 has-text-success-dark mb-0">
            {{ liveMatchesFiltered.length }} LIVE GAMES
          </p>
        </router-link>

        <div>
          <DelayedInput
            v-model="filterName"
            type="search"
            icon="search"
            placeholder="Type player name to search..."
          />
        </div>
        <div>
          <MatchesTable
            :currentMatch="currentMatch"
            :matches="liveMatchesFiltered"
          />
        </div>
        <button
          style="margin-top: 20px;"
          class="button is-warning"
          @click="showLiveGames = false"
        >
          Hide Live Games
        </button>
      </div>
    </div>

    <!-- <div>
      <p class="subtitle is-3 has-text-grey">RECENT GAMES</p>
      <MatchesTable
        :currentMatch="currentMatch"
        :matches="recentMatches"
        color="grey"
      />
    </div> -->

    <div class="app__dev">
      <p v-if="userId">uId {{ userId }}</p>
      <p>Firestore Time Offset {{ Number(firestoreTimeOffset).toFixed(1) }}s</p>
      <p>RTDB Time Offset {{ rtdbTimeOffset }}ms</p>
    </div>
  </div>
</template>

<script>
import LobbyRenderless from "@/components/lobby/LobbyRenderless.vue";
import CreateGame from "@/components/lobby/CreateGame.vue";
import MatchesTable from "@/components/tables/MatchesTable.vue";
import { mapGetters } from "vuex";
import PlayersCarousel from "@/components/lobby/PlayersCarousel.vue";
import DelayedInput from "../components/DelayedInput";
import { isAfter } from "vue-chess-shared/utils/date-helper";
import { addDuration } from "vue-chess-shared/utils/date-helper";

export default {
  name: "Lobby",
  title() {
    return "Lobby";
  },

  components: {
    DelayedInput,
    CreateGame,
    PlayersCarousel,
    MatchesTable,
  },

  extends: LobbyRenderless,

  data() {
    return { showLiveGames: true };
  },

  computed: {
    ...mapGetters(["getOnlinePlayers"]),

    liveMatchesFiltered() {
      let filteredMatches = [];
      if (this.filterName) {
        filteredMatches = this.liveMatches
          .filter(
            (match) =>
              (match.player1.name &&
                match.player1.name
                  .toLowerCase()
                  .includes(this.filterName.toLowerCase())) ||
              (match.player2.name &&
                match.player2.name
                  .toLowerCase()
                  .includes(this.filterName.toLowerCase()))
          )
          .sort((a, b) => b.gameOverride - a.gameOverride);
      } else {
        filteredMatches = this.liveMatches
          .slice()
          .sort((a, b) => b.gameOverride - a.gameOverride);
      }

      const showAll =
        this.$route.query.showAll || this.$route.query.showall || false;

      if (showAll) {
        return filteredMatches;
      } else {
        const twoHoursAgo = addDuration(new Date(), -2, "hour");
        return filteredMatches.filter((m) => {
          return m.createdAt && isAfter(m.createdAt, twoHoursAgo);
        });
      }
    },
  },

  watch: {
    matches: function() {
      setTimeout(() => {
        const duration = parseInt(this.$route.query.duration ?? 0);
        const increment = parseInt(this.$route.query.increment ?? 0);

        if (duration && duration % 60 === 0) {
          this.createOrJoinMatch(duration, increment ?? 0);
          const query = Object.assign({}, this.$route.query);
          delete query.duration;
          delete query.increment;
          this.$router.replace({ query });
        }
      }, 1000);
    },
  },
};
</script>

<style scoped>
.lobby {
  position: relative;
}

.lobby__header {
  display: flex;
  justify-content: space-between;
  max-width: 100%;
}

.lobby__headerLeft {
  width: calc(100% - 21rem);
}

.lobby__headerRight {
  width: 20rem;
}

.app__dev {
  text-align: right;
  color: grey;
  font-size: 12px;
  position: absolute;
  bottom: 0;
  right: 0;
  padding: 15px 15px 10px;
}

@media only screen and (max-width: 40rem) {
  .lobby__header {
    flex-direction: column;
    align-items: center;
  }

  .lobby__headerLeft {
    width: 100%;
  }

  .lobby__headerRight {
    order: -1;
  }
}
</style>
